import { render } from "./SoporteCsa.vue?vue&type=template&id=303290ec"
import script from "./SoporteCsa.vue?vue&type=script&lang=js"
export * from "./SoporteCsa.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__